import { render, staticRenderFns } from "./c-select-item@.vue?vue&type=template&id=08be4f3f&"
import script from "./c-select-item@.vue?vue&type=script&lang=ts&"
export * from "./c-select-item@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports